import apiClient from "./apiClient";

const client = apiClient();

client.registerTransformer({
  type: ["item", "item-without-variants"],
  deserialize: (data) => ({
    ...data,
    itemTypeName: data.type,
  }),
});

export default client;
